export const categories = [
  {
    slug: 'life-record',
    name: '生活记录',
    icon: 'ri-calendar-check-line',
    description: '记录日常生活点滴，分享真实人生故事',
    color: 'primary',
    imageSeq: 'cat-life',
  },
  {
    slug: 'travel-vlog',
    name: '旅行Vlog',
    icon: 'ri-earth-line',
    description: '足不出户看世界，跟随镜头去旅行',
    color: 'accent',
    imageSeq: 'cat-travel',
  },
  {
    slug: 'food-explore',
    name: '美食探店',
    icon: 'ri-restaurant-line',
    description: '探寻城市角落的隐藏美味',
    color: 'primary',
    imageSeq: 'cat-food',
  },
  {
    slug: 'creative-short',
    name: '创意短片',
    icon: 'ri-lightbulb-flash-line',
    description: '脑洞大开的创意作品，激发无限想象',
    color: 'accent',
    imageSeq: 'cat-creative',
  },
  {
    slug: 'tech-digital',
    name: '数码科技',
    icon: 'ri-smartphone-line',
    description: '数码产品测评与科技前沿分享',
    color: 'secondary',
    imageSeq: 'cat-tech',
  },
  {
    slug: 'pet-cute',
    name: '萌宠日常',
    icon: 'ri-heart-pulse-line',
    description: '治愈系萌宠日常，温暖你的每一天',
    color: 'secondary',
    imageSeq: 'cat-pet',
  },
  {
    slug: 'fashion-beauty',
    name: '时尚美妆',
    icon: 'ri-palette-line',
    description: '美妆教程与时尚穿搭灵感分享',
    color: 'accent',
    imageSeq: 'cat-fashion',
  },
  {
    slug: 'fitness-sport',
    name: '运动健身',
    icon: 'ri-run-line',
    description: '运动健身教程与健康生活指南',
    color: 'secondary',
    imageSeq: 'cat-fitness',
  },
];

export const allCategorySlugs = categories.map((c) => c.slug);